<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body style="background:#fff;padding:17px;">
      <div class="item-box">
        <div class="item-box-title">
          投资者：金融机构投资者预约订单时可以创建产品，填写产品名称、产品投资者基本信息表、
          产品证明资料即可添加产品，需要管理人后台审核
          <br/>
          理财师：理财师为金融机构投资者创建产品订单时，可以帮助金融机构创建产品。填写产品名称、
          产品投资者基本信息表、产品证明资料即可添加产品。需要管理人后台审核
        </div>
        <div class="item-box-slide">
          <cube-slide :initialIndex="slideNorIndex" :showDots="false" :autoPlay="false" @change="slideNorChange">
            <cube-slide-item>
              <img src="~@/assets/create1.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/create2.png" width="100%">
            </cube-slide-item>
            <cube-slide-item>
              <img src="~@/assets/create3.png" width="100%">
            </cube-slide-item>
          </cube-slide>
          <div class="item-box-slide-desc">
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;" >
              <i class="cubeic-back"></i>
            </div>
            <div class="item-box-slide-desc-n">
              <span>{{`0${slideNorIndex + 1}`}}</span>/03
            </div>
            <div class="item-box-slide-desc-text">{{['点击添加', '添加产品', '提交产品'][slideNorIndex]}}</div>
            <div @click="$_jumpSlideItemNor(slideNorIndex)" style="color:#222;">
              <i class="cubeic-arrow"></i>
            </div>
          </div>
        </div>
      </div>

    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      slideNorIndex: 0,
    };
  },
  methods: {
    slideNorChange(index) {
      this.slideNorIndex = index;
    },
    $_jumpSlideItemNor(index) {
      if (index < 2) {
        this.slideNorIndex = index + 1;
      } else {
        this.slideNorIndex = 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-box {
  margin-bottom: 30px;
  .item-box-title {
    font-size: 13px;
    color: #666666;
    line-height: 18px;
    span {
      color: #FF9800;
    }
  }
  .item-box-slide {
    margin: 10px 0;
    border: 1px solid #eee;
    .item-box-slide-desc {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      padding: 10px 0;
      color: #999;
      .item-box-slide-desc-n > span {
        color: #2E6BE6;
      }
      .item-box-slide-desc-text {
        flex: .6;
        font-size: 15px;
      }
    }
  }
}
</style>
